import React from "react";
import { Sparkles } from "lucide-react";

export default function LoyaltyBadge({ className = "", label = "Loyalty Club" }) {
  return (
    <span data-testid="loyalty-club-badge" title="Loyalty Club merchant"
      className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-[#EE9B00] to-[#CA6702] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white shadow-sm ${className}`}>
      <Sparkles size={10} strokeWidth={2.6} /> {label}
    </span>
  );
}
